module.exports = __webpack_public_path__ + "img/com9.e602e034.gif";